<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('report.resource_type')"
    icon="res-resource-type-setting"
    :res-name="detailData.name"
    :actions="params.actions"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions :options="singleActions" :row="detailData" button-type="link" button-size="small" />
    </template>
    <component :is="params.windowData.currentTab" :id="listId" :res-id="data.id" :data="detailData" :onManager="onManager" resource="jobs" :getParams="getParams" :showSearchbox="false" :showGroupActions="false" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import Detail from './Detail'
import AssociatedList from './AssociatedList.vue'

export default {
  name: 'ResourceTypeSettingSidePage',
  components: {
    Actions,
    Detail,
    AssociatedList,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('common_386'), key: 'detail' },
        { label: this.$t('report.associated_resource_type'), key: 'associated-list' },
        { label: this.$t('compute.text_240'), key: 'event-drawer' },
      ],
    }
  },
  computed: {
    getParams () {
      if (this.params.windowData.currentTab === 'associated-list') {
        return {
          id: this.detailData.parent_id || 'no-parent-id',
        }
      }
      return {}
    },
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'event-drawer':
          return 'EventListForResourceTypeSettingSidePage'
        case 'associated-list':
          return 'AssociatedListForResourceTypeSettingSidePage'
        default:
          return ''
      }
    },
  },
  created () {
    this.$bus.$on('updateResourceTypeParent', (id) => {
      this.refresh()
    })
  },
}
</script>
